import { isNumber } from '@cdab/utils'
import { observer } from 'mobx-react-lite'
import { useParams, useRouteLoaderData } from 'react-router-dom'
import invariant from 'tiny-invariant'

import {
  CheckpointList,
  Column,
  Container,
  EmptyScreen,
  Row,
  ScrollableWrapper
} from '@cdab/scania/qpr/components'

import { TdsIcon } from '@scania/tegel-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import type { AuditLoaderData } from '../../../../auditId'

export const Content = styled.div`
  height: 100%;
`

type Params = {
  auditId: string
  auditPointId: string
}

export const CheckPointsTab = observer(() => {
  const params = useParams<Params>()
  const { t } = useTranslation(['audit', 'common'])

  const auditPointId = Number.parseInt(params.auditPointId || 'NaN')
  invariant(isNumber(auditPointId), 'auditPointId is required')

  const { audit } = useRouteLoaderData('audit') as AuditLoaderData

  const checkPointsForAuditPoints = audit.checkPoints.filter(
    checkpoint => checkpoint.auditPointId === Number(auditPointId)
  )

  return (
    <Content>
      <Container paddingOnContainer={false} fullHeight>
        <Row fullHeight>
          <Column width={12} padding={false}>
            {checkPointsForAuditPoints.length > 0 ? (
              <ScrollableWrapper>
                <CheckpointList
                  audit={audit}
                  checkPoints={checkPointsForAuditPoints}
                />
              </ScrollableWrapper>
            ) : (
              <EmptyScreen.CenteredWrapper>
                <EmptyScreen
                  icon={<TdsIcon name='message_inactive' size='lg' />}
                  title={t('no-checkpoints', { ns: 'common' })}
                />
              </EmptyScreen.CenteredWrapper>
            )}
          </Column>
        </Row>
      </Container>
    </Content>
  )
})
